<script>
  import BookCover from '../BookCover.svelte';
  import { stores } from '@sapper/app';
  import FavIcon from '../FavIcon.svelte';
  import { user } from '../../stores';

  const { session } = stores();

  export let book; // Book
  let isDeferred = book.productCard.isDeferred;

  const toggleFavorite = () => {
    const { id: productId, title } = book;
    isDeferred ?
      user.undeferBook({ productId }) :
      user.deferBook({ productId }, title);

    isDeferred = !isDeferred;
  };
</script>

<style lang="stylus">
  .cover-borders
    display inline-block
    position relative

    button
      position absolute
      right 8px
      top 8px
      width 40px
      height 40px
      border none
      border-radius 50%
      background rgba(0, 0, 0, 0.24)
      cursor pointer
      transition background-color 0.2s ease-in-out
      outline none

      &:hover
        background rgba(0, 0, 0, 0.4) !important

      :global(svg.fav-icon)
        //stroke #DCDCDC
        width 12px

      @media $bp.desktop
        width 57px
        height 57px
        right 16px
        top 16px

        :global(svg.fav-icon)
          width 19px
</style>

<div class="cover-wrapper">
  <div class="cover-borders">
    <BookCover cover={book.cover} bordered={false} shadow size="large" alt={book.title} />
    {#if $session.user}
      <button class:deferred={isDeferred} on:click={toggleFavorite}>
        <FavIcon active={isDeferred} />
      </button>
    {/if}
  </div>
</div>
